(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/login-iam/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/login-iam/assets/javascripts/init.js');

'use strict';

const {
  ErrorBoundary
} = svs.components.errorBoundary;
const LoginIam = svs.login_iam.LoginIam;
ReactDOM.render(React.createElement(ErrorBoundary, null, React.createElement(LoginIam, null)), document.getElementsByClassName('js-react-container')[0]);

 })(window);